import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { default as DefaultModal } from '@material-ui/core/Modal';
import './style.css';

export default function Modal({ open, setOpen, body, className }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <DefaultModal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <div className={className}>{body}</div>
      </DefaultModal>
    </div>
  );
}
